import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    Dropdown,
    Button,
} from 'antd';
import {
    // LogOutIcon,
    UserIcon,
    EditIcon,
} from '@/assets/images/icons';
import { logout } from '@/redux/authentication/login/loginSlice';

const UserMenu = ({ setSelectedKeys }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const firstName = useSelector((state) => state.profile.userProfile?.first_name);
    const lastName = useSelector((state) => state.profile.userProfile?.last_name);

    const items = [
        {
            label: `${firstName} ${lastName}`,
            icon: <div><UserIcon /></div>,
            key: 'USER',
        },
        {
            label: (
                <Button
                    type="text"
                    onClick={() => {
                        navigate('/app/profile');
                        setSelectedKeys(['PROFILE']);
                    }}
                >
                    Edit Profile
                </Button>
            ),
            icon: <div><EditIcon /></div>,
            key: 'PROFILE',
        },
        {
            icon: <div><UserIcon /></div>,
            label: (
                <Button
                    type="text"
                    onClick={() => dispatch(logout())}
                >
                    Log out
                </Button>
            ),
            key: 'LOGOUT',
        },
    ];

    return (
        items
    );
};

function TopbarUserMenu({ setSelectedKeys }) {
    return (
        <Dropdown
            trigger={['click']}
            overlayClassName="user-dropdown"
            menu={{
                items: UserMenu({ setSelectedKeys }),
            }}
        >
            <div className="user-icon-wrapper">
                <UserIcon />
            </div>
        </Dropdown>
    );
}

export default TopbarUserMenu;
